import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectGettingOrganizationCurrenciesFromState,
  selectGettingReceiptRulesFromState,
} from 'src/app/OrganizationInfo/redux/organizationInfo.selectors'
import Box from 'src/components/Box/Box'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import OrgSettingsReceiptRulesBoxContent from 'src/components/OrgSettingsReceiptRulesBox/OrgSettingsReceiptRulesBoxContent'
import OrgSettingsReceiptRulesForm from 'src/components/OrgSettingsReceiptRulesForm/OrgSettingsReceiptRulesForm'
import SvgUpdate from 'src/components/Svgs/SvgUpdate'
import Trns from 'src/localization/Trns'
import { OrganizationsListModel } from 'src/models/organizations.models'
import { UserListModel } from 'src/models/user.models'
import { css } from 'styled-components'

interface OrgSettingsReceiptRulesBoxProps {
  user?: UserListModel
  organization: OrganizationsListModel
}

const OrgSettingsReceiptRulesBox: React.FC<OrgSettingsReceiptRulesBoxProps> = (
  props,
): React.ReactElement => {
  const { user, organization } = props
  const { receiptRule, currencies, id } = organization

  const gettingReceiptRules = useSelector(selectGettingReceiptRulesFromState)
  const gettingOrganizationCurrencies = useSelector(
    selectGettingOrganizationCurrenciesFromState,
  )
  const loadingReceiptRules =
    gettingReceiptRules || gettingOrganizationCurrencies
  const [isReceiptRulesBeingEdited, setIsReceiptRulesBeingEdited] =
    useState<boolean>(false)

  return (
    <Box className={'flex-column'} noShadow outlineBorder>
      {loadingReceiptRules ? (
        <LoadingBackgroundPage />
      ) : (
        <>
          <div
            css={css`
              margin-bottom: 16px;
              display: flex;
              justify-content: space-between;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  20,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              <Trns source={'Receipt Rules'} />
            </span>
            {user?.hasOrgAdminPermissions && !isReceiptRulesBeingEdited && (
              <HoverableLink
                onClick={(): void => {
                  setIsReceiptRulesBeingEdited(true)
                }}
                ariaLabelSource={'Update'}
                css={css`
                  display: flex;
                  align-items: center;
                `}
                testId={'updateReceiptRulesBtn'}
              >
                <Trns source={'Update'} />
                <SvgUpdate
                  css={css`
                    transform: scale(0.7);
                    margin-left: 4px;
                  `}
                />
              </HoverableLink>
            )}
          </div>
          {isReceiptRulesBeingEdited && currencies ? (
            <OrgSettingsReceiptRulesForm
              receiptRules={receiptRule}
              currencies={currencies}
              closeReceiptRulesForm={(): void => {
                setIsReceiptRulesBeingEdited(false)
              }}
              orgId={id}
              hasRecurringCards={!!organization.hasRecurringCards}
              hasPhysicalTransactions={!!organization.physicalClearingsEnabled}
            />
          ) : (
            <OrgSettingsReceiptRulesBoxContent
              receiptRule={organization.receiptRule}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default OrgSettingsReceiptRulesBox
